// extracted by mini-css-extract-plugin
module.exports = {"_icon":"UnderConstruction__icon__Y-5nE","_message":"UnderConstruction__message__OVnw7"};